import { AxiosResponse } from 'axios';
import { SET_YURTZEITEN_DESIGN_N, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_YURTZEITEN_DESIGN_N_ISLOADING,
  GET_YURTZEITEN_DESIGN_N,
  SAVE_YURTZEITEN_DESIGN_N,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import YurtzeitenDesign_N from '@/services/yurtzeiten_design_N';
import { Module } from 'vuex';
import {
  GetYurtzeitenDesign_N,
  SaveYurtzeitenDesign_N,
} from '@/dtos/yurtzeiten_design_N.dto';

const yurtzeiten_design_N: Module<any, {}> = {
  state: {
    // One org-wide row. `data` stays null until the org has saved a design at
    // least once, which is the signal the editor uses to fall back to its
    // built-in template defaults.
    yurtzeitenDesign_N: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    yurtzeitenDesign_N: (state: { yurtzeitenDesign_N: any }) => state.yurtzeitenDesign_N,
  },
  mutations: {
    [SET_YURTZEITEN_DESIGN_N]: (
      state: { yurtzeitenDesign_N: StateObject },
      payload: { data: any; isLoading: any; clearData?: boolean }
    ) => {
      // The other modules only ever write a non-null `data`, which leaves no way
      // to represent "this organization has no design row". `clearData` is that
      // way — a plain null payload still means "leave what is there".
      if (payload.clearData) {
        state.yurtzeitenDesign_N.data = null;
      } else if (payload.data != null) {
        state.yurtzeitenDesign_N.data = payload.data;
      }
      state.yurtzeitenDesign_N.isLoading = payload.isLoading;
    },
  },
  actions: {
    [GET_YURTZEITEN_DESIGN_N]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_DESIGN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await YurtzeitenDesign_N.getYurtzeitenDesign_N(
        payload as GetYurtzeitenDesign_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_DESIGN_N, {
            data: result.data.data,
            // A first visit answers with a null design; that is the answer, not
            // a missing one, so the previous org's row is cleared out.
            clearData: result.data.data == null,
            isLoading: false,
          });
          return true;
        }
        commit(SET_YURTZEITEN_DESIGN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_DESIGN_N, { isLoading: false });
        return false;
      }
    },
    [SAVE_YURTZEITEN_DESIGN_N]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_DESIGN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await YurtzeitenDesign_N.saveYurtzeitenDesign_N(
        payload as SaveYurtzeitenDesign_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_DESIGN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_DESIGN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_DESIGN_N, { isLoading: false });
        return false;
      }
    },
    [CLEAR_YURTZEITEN_DESIGN_N_ISLOADING]: ({ commit }) => {
      commit(SET_YURTZEITEN_DESIGN_N, { isLoading: false });
    },
  },
};

export default yurtzeiten_design_N;
